import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Collapse, Skeleton, Tooltip } from 'antd';
import { Panel } from '../../../../common/component/Collapse';
import Wrapper from '../../../../common/component/Wrapper';
import { FormWrapperItem, ListComponent, StatusComponent } from '../../../../common/component/Index';
import * as Func from '../../../../../../helpers/functions';
import { FixChargeItem, SmsHistory } from '../../../../../../models/Order';
import { getMomentDate } from '../../../../../../utils/commonUtils';
import { DATE_TIME_FORMAT } from '../../../../../../constants/Define';
import { useLocation, useParams } from 'react-router-dom';
import { useGetAllExchargeOrderData } from '../../../../../../hook/exchargeOrder/useExchargeOrder';
import telegramPlane from '../../../../../../assets/images/telegram-plane.svg';

const OrderVinWonderItemKeys = Object.getOwnPropertyNames(new FixChargeItem());
const removedColumns = [
    'id', "createdDate","action"
];
const FixchargeInfo = (props) => {
    //! State
    const {t} = useTranslation();
    const {id} = useParams();
    const {loading, onResend, smsHistories} = props;
    const modelItem = OrderVinWonderItemKeys;
    const {data: fixchargeData, error, isLoading, refresh} = useGetAllExchargeOrderData(id);
    const titleItemTable = Func.getTitleTable(['index', ...OrderVinWonderItemKeys], [], removedColumns);
    const componentTable = {
        index: {
            align: 'center',
            render: (date, record, index) => index + 1
        },
        fixchargeCode: {
            align: 'center',
            key: 'fixchargeCode'
        },
        itiNumber: {
            align: 'center',
            key: 'itiNumber'
        },
        resCode: {
            align:'center',
            key: 'reservationCode'
        },
        amount: {
            align: 'center',
            key:'amount'
        },
        fixchargeStatus: {
            align: 'center',
            key: 'fixchargeStatus',
            width: 100,
            render: (value, record) => {
                const style = handleFilterRenderStatus(value);
                return(
                    <Fragment>
                        <StatusComponent color={style?.color} label={t(`item.order.orderFixcharge.${style?.title}`)}/>
                    </Fragment>
                )
            },
        }
    }
    //! Function
    const handleFilterRenderStatus = (value) => {
        switch(value){
            case 1:
                return {
                    color: 'green',
                    title: 'completed'
                }
            case 2:
                return{
                    color: 'red',
                    title: 'failed'
                }
            case 3:
                return{
                    color: 'orange',
                    title: 'pending'
                }
            default: 
                return {
                    color: 'red',
                    title: 'failed'
                }
        }
    }

    const handleResend = () => {
        const ids = fixchargeData.filter((el) => el.action === true).map(el => el.id);
        onResend(ids);
        refresh && refresh();
    }
    //! Effect

    //! Render
    if(fixchargeData?.length === 0) {
        return(
            <></>
        )
    }
  return (
    <Collapse className='my-3 w-100' style={{backgroundColor: "white"}} defaultActiveKey={['1']} bordered={false} expandIconPosition='right'>
        <Panel header={
            <h3 className={`m-0`} style={{color:"#676a6c"}}>{t('item.order.fixchargeCreated')}</h3>
        } key="1" >
            <Wrapper className="col-md-12 sms-histories-section">
                <Wrapper className={`row mt-2 mb-3`}>
                    <FormWrapperItem classParent="p-0" classChildren="m-0 p-0" style={{width: '100%'}}>
                        {!isLoading ?
                        <div style={{display:'flex',width: '100%'}}>
                            <ListComponent
                                classParent="m-0 p-0 col-md-12"
                                marginTop={'0'} marginBottom={'0'}
                                loading={{ spinning: isLoading, size: 'large' }}
                                rowKey={(record, k) => k}
                                // dataSource={Func.getDataSource(smsHistories, modelItem)}
                                dataSource={fixchargeData}
                                columns={Func.columnsTable({
                                    titleTable: titleItemTable,
                                    component: componentTable,
                                    itemName: t('order.orderFixcharge')
                                })}
                                componentTableList={{}}
                                hideSettings={true}
                            />
                            {
                                fixchargeData?.some(el => el.action === true) && 
                            
                                <div style={{marginTop: '46px', display: 'grid',placeItems:'center', marginLeft: '1rem'}}>
                                    <Tooltip title={t(`item.order.orderSmsHistories.action`)} placement="top">
                                        <img src={telegramPlane} width={20} className="cursorPointer"  onClick={handleResend} />
                                    </Tooltip>
                                </div>
                            }
                        </div>
        
                            : <Skeleton active paragraph={{ row: 3 }} className="p-4" />
                        }
                    </FormWrapperItem>
                </Wrapper>
            </Wrapper>
        </Panel>
    </Collapse>
  )
}

export default FixchargeInfo